import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './qrcodeScanner.module.scss'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import QRCodeScanner from '@/components/QRCodeScanner/QRCodeScanner'

interface qrCodeScannerDialogProps {
    open: boolean
    handleClose: () => void
    parent: boolean
    setAutoLinkURL: (url: string) => void
}

const QRCodeScannerDialog: FunctionComponent<qrCodeScannerDialogProps> = ({
    open,
    handleClose,
    parent,
    setAutoLinkURL
}: qrCodeScannerDialogProps) => {
    const { t } = useTranslation()

    function onScan(data: string): void {
        if (data) {
            setAutoLinkURL(data)
            handleClose()
        }
    }

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('scanWithQRCode')} parent={parent} />
            <DialogBody className={styles.DialogBody}>
                <div className={styles.QRCode}>
                    <QRCodeScanner onScan={onScan} isParent={parent} />
                </div>
                <ButtonTextIcon type={'return'} onClick={handleClose} fullWidth parent={parent} />
            </DialogBody>
        </Dialog>
    )
}

export default QRCodeScannerDialog
